import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { EuroCircleOutlined } from '@ant-design/icons';
import { UserRole, withRoleGuard } from 'shared/hocs/with-role-guard.tsx';
import { InvoiceStatusEditModal } from './components/invoice-status-edit-modal';
import type { IInvoiceStatusEditProps } from './types';

export const InvoiceStatusEditComponent: React.FC<IInvoiceStatusEditProps> = (props) => {
  const { invoiceId, currentStatus } = props;
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpen = () => setIsModalOpen(true);
  const handleClose = () => setIsModalOpen(false);

  return (
    <>
      <Button icon={<EuroCircleOutlined />} onClick={handleOpen}>
        {t('invoice:status')}
      </Button>
      <InvoiceStatusEditModal
        isOpen={isModalOpen}
        currentStatus={currentStatus}
        invoiceId={invoiceId}
        onClose={handleClose}
      />
    </>
  );
};

export const InvoiceStatusEdit = withRoleGuard<IInvoiceStatusEditProps>(InvoiceStatusEditComponent, [
  UserRole.admin,
  UserRole.assistant,
  UserRole.accountant,
]);
